import { Grid, Button, Paper, Typography } from '@mui/material'
import AlertDialog from 'components/Dialog/AlertDialog'
import FullPageLayout from 'components/FullPageLayout/FullPageLayout'
import { useEffect, useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useFormat } from 'Services/localize/format'
import { useAppSelector } from 'store/useStoreHook'
import OrderwireLogo from 'views/CreateCompany/components/OrderwireLogo'
import ContactSupportButton from './ContactSupportButton'
import useLicenseRenew from './useLicenseRenew'

function LicenseExpiredPage() {
    const tenantIdentifierInfo = useAppSelector(
        (state) => state.tenantIdentifierInfo.data,
    )
    const license = tenantIdentifierInfo.companyLicense!

    const { t } = useTranslation()
    const { humanDateFormat } = useFormat()
    const { renewLicense, renewLicenseResult, processing } = useLicenseRenew()
    const [showRenewLicense, setShowRenewLicense] = useState(false)

    const isDemoLicense = useMemo(
        () => license.licenseOfferType?.toLocaleLowerCase() === 'demo',
        [license.licenseOfferType],
    )

    useEffect(() => {
        if (renewLicenseResult) {
            setShowRenewLicense(true)
        }
    }, [renewLicenseResult])

    return (
        <>
            <FullPageLayout>
                <>
                    <OrderwireLogo />
                    <Typography variant="h5">
                        {isDemoLicense
                            ? t('license.message.demo_licensed_expired')
                            : t('license.message.licensed_expired')}
                    </Typography>
                    <Typography
                        style={{ marginTop: 24 }}
                        textAlign="left"
                        fontWeight="bold"
                    >
                        Company Information:{' '}
                    </Typography>
                    <Paper
                        style={{
                            textAlign: 'left',
                            padding: 8,
                            marginTop: 8,
                        }}
                    >
                        <Typography>
                            <b>Company Name: </b>
                            {tenantIdentifierInfo.companyName}
                        </Typography>
                        <Typography>
                            <b>Company Tenant ID: </b>
                            {tenantIdentifierInfo.companyTenantIdentifierID}
                        </Typography>
                    </Paper>
                    <Typography
                        style={{ marginTop: 16 }}
                        textAlign="left"
                        fontWeight="bold"
                    >
                        License Information:{' '}
                    </Typography>
                    <Paper
                        style={{
                            textAlign: 'left',
                            padding: 8,
                            marginTop: 8,
                        }}
                    >
                        <Typography>
                            <b>Plan: </b>
                            {license.licenseOfferType ?? 'N/A'}
                        </Typography>
                        <Typography>
                            <b>Expired on: </b>
                            {humanDateFormat(license.validToDate ?? '') ||
                                'N/A'}
                        </Typography>
                    </Paper>
                    {isDemoLicense ? (
                        <Grid
                            container
                            justifyContent="space-between"
                            style={{ marginTop: 24 }}
                        >
                            <Grid>
                                <Button
                                    color="warning"
                                    disabled={processing}
                                    onClick={() => renewLicense()}
                                >
                                    {processing
                                        ? 'Processing...'
                                        : t('license.button.renew_license')}
                                </Button>
                            </Grid>
                            <Grid>
                                <ContactSupportButton />
                            </Grid>
                        </Grid>
                    ) : (
                        <ContactSupportButton style={{ marginTop: 24 }} />
                    )}
                </>
            </FullPageLayout>
            <AlertDialog
                open={showRenewLicense}
                onClose={() => window.location.reload()}
            >
                {t('license.message.success_renew', {
                    validFrom: humanDateFormat(
                        renewLicenseResult?.validFromDate ?? '',
                    ),
                    validTo: humanDateFormat(
                        renewLicenseResult?.validToDate ?? '',
                    ),
                })}
            </AlertDialog>
        </>
    )
}

export default LicenseExpiredPage
